import React from 'react';
import PropTypes from 'prop-types';
import {
  FDStack, FDTextButton,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { v4 as uuid } from 'uuid';
import LeverFieldLayout from './LeverLayouts/leverFieldLayout';
import { metaOverrideSet } from './metaOverrideSet';

const LeverSetLayout = ({
  loading,
  setLoading,
  setSaving,
  matchesSearchTerm,
  searchTerm,
  onTogglePinOptimistic,
  onLeverUpdate,
  isPinnedOptimistically = false,
}) => {
  const {
    resource,
    handleChange,
  } = useMetaLayoutContext();

  // Include the lever if we don't have a match function or there is no search term or the lever matches the search term
  const filteredSetLevers = (resource.attr('levers')?.resources()?.list() || []).filter(leverRes => matchesSearchTerm == null || searchTerm == null || matchesSearchTerm(leverRes, searchTerm));
  const addLeverRelationship = resource.relationship(fr.relationships.add.name);
  if (filteredSetLevers.length === 0 && !addLeverRelationship) return null;

  return (
    <FDStack direction={'column'} spacing={1}>
      {filteredSetLevers.map((leverRes) => {
        return (
          <MetaResourceRenderer
            key={leverRes.id() || uuid()}
            resource={leverRes}
            layout={LeverFieldLayout}
            metaOverrideSet={metaOverrideSet}
            LayoutProps={{
              loading, setLoading, setSaving, onTogglePinOptimistic, isPinnedOptimistically, onLeverUpdate,
            }}
          />
        );
      })}
      {addLeverRelationship && (
        <FDTextButton
          icon={'add'}
          alignSelf={'flex-start'}
          label={resource.attr('label')}
          onClick={() => {
            resource.attr('levers').create({ addToCollection: true });
            resource.attr('levers').resources().last().attr('label', `New ${resource.attr('label') || 'lever'}`);
            handleChange('levers', resource.attr('levers'));
          }}
        />
      )}
    </FDStack>
  );
};

LeverSetLayout.propTypes = {
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  setSaving: PropTypes.func,
  matchesSearchTerm: PropTypes.func,
  searchTerm: PropTypes.string,
  onTogglePinOptimistic: PropTypes.func,
  onLeverUpdate: PropTypes.func,
  isPinnedOptimistically: PropTypes.bool,
};

export default LeverSetLayout;
